<app-loading *ngIf="contentReady"></app-loading>

<div class="mobile-finance-wrapper">

  <!-- HEADER -->
  <div class="mobile-header">
    <div class="header-info">
      <img src="/assets/income.png" [alt]="'logo' | transloco" />
      <div>
        <h2>{{ 'employeescollecting' | transloco }}</h2>
        <p>{{ 'employee sales subtitle' | transloco }}</p>
      </div>
    </div>

    <button class="print-btn noPrint" onclick="window.print()">
      <i class="fa-solid fa-print"></i>
      {{ 'Print' | transloco }}
    </button>
  </div>

  <!-- SUMMARY -->
  <div class="summary-grid">

    <div class="summary-card revenue">
      <span>{{ 'total sales' | transloco }}</span>
      <strong>{{ totalCollected | number:'1.2-2' }} {{ 'egp' | transloco }}</strong>
    </div>

    <div class="summary-card count">
      <span>{{ 'operations count' | transloco }}</span>
      <strong>{{ totalCount }}</strong>
    </div>

  </div>

  <!-- FILTERS -->
  <div class="filters-card noPrint">

    <div class="filter-group">
      <label>{{ 'employee' | transloco }}</label>
      <select class="mobile-input" [(ngModel)]="herosd" (change)="filterAllHeros()">
        <option *ngFor="let hero of AllHeros" [value]="hero.id">
          {{ hero.first_name }}
        </option>
      </select>
    </div>

    <div class="filter-row">

      <div class="filter-group">
        <label>{{ 'byday' | transloco }}</label>
        <input
          class="mobile-input"
          [(ngModel)]="date"
          (change)="dayChange()"
          type="date"
        />
      </div>

      <div class="filter-group">
        <label>{{ 'bymonth' | transloco }}</label>
        <select class="mobile-input" [(ngModel)]="selectedMonth" (change)="getByMonth()">
          <option value="">{{ 'Select Month' | transloco }}</option>
          <option *ngFor="let month of months" [value]="month.value">
            {{ isAr ? month.name_ar : month.name_en }}
          </option>
        </select>
      </div>

    </div>

  </div>

  <!-- DATA -->
  <div class="sales-list">

    <app-nodata *ngIf="hasData && !contentReady"></app-nodata>

    <div
      class="sale-card"
      *ngFor="let value of collectedFromDH; trackBy: trackById"
    >

      <div class="sale-card-top">
        <div>
          <span class="card-label">{{ 'amount' | transloco }}</span>
          <h3>{{ value.sales | number:'1.2-2' }} {{ 'egp' | transloco }}</h3>
        </div>

        <button class="delete-btn noPrint" (click)="delete(value.id)">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>

      <div class="sale-details">

        <div class="detail-item">
          <span>{{ 'Order' | transloco }}</span>
          <strong>#{{ value.order_id }}</strong>
        </div>

        <div class="detail-item">
          <span>{{ 'warehouse' | transloco }}</span>
          <strong>{{ value.warehouse?.name || '-' }}</strong>
        </div>

        <div class="detail-item full">
          <span>{{ 'date' | transloco }}</span>
          <strong>{{ value.created_at | date:'short' }}</strong>
        </div>

      </div>

    </div>

  </div>

  <!-- LOAD MORE STATUS -->
  <div class="mobile-load-state noPrint" *ngIf="!hasData">

    <div class="loading-more" *ngIf="loadingMore">
      <span class="spinner"></span>
      <p>{{ 'Loading more' | transloco }}</p>
    </div>

    <p class="end-message" *ngIf="!loadingMore && currentPage >= lastPage && collectedFromDH.length > 0">
      {{ 'All results shown' | transloco }}
    </p>

  </div>

</div>